/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const getCreatedByInformation = (conversation) => (conversation === null || conversation === void 0 ? void 0 : conversation.createdBy) &&
    Object.assign(Object.assign({}, conversation.createdBy), { createdAt: conversation.createdAt });
//# sourceMappingURL=conversation.js.map